<style scoped>


.openAILogoSpinner {
  width: 17px;
  height: 17px;
}

.openAILogoSpinner.spinning {
  animation: spin 4s linear infinite;
}

@keyframes spin {
  100% {
    transform:rotate(360deg);
  }
}
</style>


<template>
  <div style="width: 100%; max-width: 600px;">

    <v-tabs
      v-model="tab"
      v-show="shouldShowSuggestedByOpenAIResources"
    >
      <v-tab>{{ translate('ui_suggestions__suggested_by_ai') }}</v-tab>
      <v-tab @click="onAddMyOwnClick">{{ translate('ui_suggestions__add_my_own') }}</v-tab>
    </v-tabs>

    <v-tabs-items v-model="tab">
      <v-tab-item>
        <div style="width: 100%;">
          <div style="display: flex; gap: 30px; margin-top: 30px;">
            <v-text-field
              id="navigator_ask_openai_prompt"
              :label="translate('ui_suggestions__search_prompt')"
              required
              outlined
              dense
              background-color="white"
              v-model="$store.state.activeTemplate.data.openAIPrompt"
              hide-details
              :disabled="this.isCallingOpenAI"
            ></v-text-field>

            <v-btn
              @click="askOpenAI"
              :disabled="this.isCallingOpenAI"
              style="margin-right: 5px; color: #fff; background-color: darkorange;"
            >
            <span style="display: flex; gap: 3px;">
              <img
                style="width: 16px;"
                class="openAILogoSpinner"
                :class="this.isCallingOpenAI && 'spinning'"
                src="/img/openai-logomark-white.png"
              />{{ translate('ui_dialog_openai') }}
            </span>
            </v-btn>
          </div>

          <div
            v-if="this.isCallingOpenAI"
            style="display: flex; justify-content: center; gap: 10px; align-items: center; font-size: 14px; color: #676d73; margin-top: 20px;"
          >
            ... connecting to ChatGPT
            <img
              class="openAILogoSpinner spinning"
              src="/img/openai-logomark.png"
            />
          </div>

          <v-list
            style="margin-top: 20px; padding: 0px;
                    max-height: calc(100vh - 350px);
                    min-height: 200px;
                    overflow-x: hidden;"
            class="suggested-resources"
            :class="isCallingOpenAI && 'isCallingOpenAI'"
            :disabled="isCallingOpenAI"
          >
            <v-list-item-group>
              <v-list-item
                v-for="(resource, i) in section.suggestedResources"
                :key="i"
                style="min-height: initial;"
                @click="selectResource(resource)"
              >
                <v-list-item-action
                  style="align-self: center; margin-right: 12px;"
                >
                  <v-checkbox
                    :input-value="resource.isSelected"
                    :disabled="isCallingOpenAI"
                  ></v-checkbox>
                </v-list-item-action>
                <v-list-item-content style="cursor: pointer;">
                  <v-list-item-title
                    style="display: flex; justify-content: space-between; font-size: 16px;"
                  >
                    <div
                      :title="resource.name"
                    >{{resource.name}}</div>
                  </v-list-item-title>
                  <!--
                  <v-card-subtitle
                    v-if="resource.formula"
                    style="padding: 5px 0; text-align: left; font-size: 12px;"
                  >
                    {{resource.formula}}
                    {{ resource.formula.name[$store.state.activeTemplate.language] || resource.formula.name}}
                  </v-card-subtitle>
                  -->
                </v-list-item-content>
              </v-list-item>
            </v-list-item-group>
          </v-list>

          <div style="margin: 30px 0 2px; display: flex; gap: 30px; justify-content: center;">
            <v-btn
              color="primary"
              @click="saveSelected"
            >
              {{ translate('ui_suggestions__btn_save') }}
            </v-btn>
          </div>

        </div>
      </v-tab-item>
      <v-tab-item>
        <div style="flex: 1 1 0; display: flex; flex-direction: column; align-items: center; justify-content: center;">
          <DialogResourceAdd
            :section="section"
            :shouldHideCancelBtnFromParent="true"
            :shouldHideAITabFromParent="true"
          />
        </div>
      </v-tab-item>
    </v-tabs-items>
<!--
    <div
      v-if="section.canSkip"
      style="margin-top: 60px; font-size: 14px; display: flex; flex-direction: column;"
    >
      {{ translate('ui_suggestions__can_skip1') }}
      <b>{{ translate(section.id) }}</b>{{ translate('ui_suggestions__can_skip2') }}
      <div>
        <v-btn
          small
          data-qa="dialog_resource_add__skip_btn"
          @click="skipSection(section.id)"
          style="margin-left: 30px; margin-top: 30px;"
        >
          {{ translate('ui_skip_btn') }}
        </v-btn>
      </div>
    </div>
    -->
  </div>

</template>

<script>
import Mixin from '@/mixins/mixin';
import DialogResourceAdd from '@/components/dialogs/DialogResourceAdd.vue';

export default {
  name: 'DialogResourceSuggestions',
  components: { DialogResourceAdd },
  mixins: [Mixin],
  props: {
    section: Object,
  },
  data: () => ({
    tab: 0,
    isCallingOpenAI: false,
  }),
  mounted() {
    this.tab = this.shouldShowSuggestedByOpenAIResources ? 0 : 1;
  },
  computed: {
    selectedResources() {
      return this.section.suggestedResources.filter((resource) => resource.isSelected);
    },
    shouldShowSuggestedByOpenAIResources() {
      const noShowSections = ['section_financing'];
      return !noShowSections.includes(this.section.id);
    },
  },
  methods: {
    onAddMyOwnClick() {
      const sectionIndex = this.$store.state.activeTemplate.data.sections.findIndex((sectionInState) => sectionInState.id === this.section.id);
      this.$store.dispatch('updateState', {
        path: `activeTemplate.data.sections[${sectionIndex}].isAddingResource`,
        value: true,
      });
    },
    async askOpenAI() {
      this.isCallingOpenAI = true;
      await this.$store.dispatch('getOpenAI', {
        searchString: this.$store.state.activeTemplate.data.openAIPrompt,
        sectionId: this.section.id,
      });
      this.isCallingOpenAI = false;

      // auto add to section
      // this.selectedResources = this.suggestedResources.map((item) => {
      //   // eslint-disable-next-line
      //   item.isSelected = true
      //   return item;
      // });
      // this.saveSelected();
    },
    selectResource(resource) {
      // eslint-disable-next-line
      resource.isSelected = !resource.isSelected;
      // this.selectedResources = this.section.suggestedResources.filter((res) => res.isSelected);
    },
    saveSelected() {
      // const sectionIndex = this.$store.state.activeTemplate.data.sections.findIndex((sect) => sect.id === this.section.id);
      // this.section = this.$store.state.activeTemplate.data.sections[sectionIndex];
      // debugger;
      if (this.section.sectionResources) {
        for (let i = 0; i < this.selectedResources.length; i++) {
          const selectedResource = this.selectedResources[i];
          const { formula } = selectedResource;
          if (formula) {
            // check if the formula is already there in formulas
            const formulaExists = this.$store.state.activeTemplate.data.formulas.find((f) => f.id === formula.id);
            if (!formulaExists) {
              const { language } = this.$store.state.activeTemplate;
              formula.name = formula.name[language];
              formula.variables.forEach((variable) => {
                // eslint-disable-next-line
                variable.name = variable.name[language];
                if (typeof variable.units === 'object') {
                  // eslint-disable-next-line
                  variable.units = variable.units[language];
                }
                return variable;
              });
              // save formula in the template formulas
              const { formulas } = this.$store.state.activeTemplate.data;
              formulas.push(formula);
              this.$store.commit('updateState', {
                path: 'activeTemplate.data.formulas',
                value: formulas,
              });
            }
          }

          const { rel } = selectedResource;
          // eslint-disable-next-line
          const sectionResource = this.createNewSectionResource(this.section, rel, formula && formula.id);
          sectionResource.coreResource.name = `${this.selectedResources[i].name}`;
          // save new coreResource
          const { coreResources } = this.$store.state.activeTemplate.data;
          coreResources.push(sectionResource.coreResource);
          this.$store.commit('updateState', {
            path: 'activeTemplate.data.coreResources',
            value: coreResources,
          });

          // setTimeout(() => {
          //   const resource = document.getElementById(`section-resource-${sectionResource.id}`);
          //   resource.classList.add('just-added');
          //   setTimeout(() => {
          //     resource.classList.remove('just-added');
          //   }, (i + 1) * 250);
          // }, (i + 1) * 100);

          // TODO - need this?
          const { sectionResources } = this.$store.state.activeTemplate.data.divisions[0];
          sectionResources.push(sectionResource);
          this.$store.commit('updateState', {
            path: 'activeTemplate.data.sectionResources',
            value: sectionResources,
          });
        }

        // unselect
        // this.selectedResources.forEach((resource) => {
        //   // eslint-disable-next-line
        //   resource.isSelected = false;
        //   // remove from suggested
        //   if (this.section.id !== 'section_financing') {
        //     this.section.suggestedResources.splice(0, 1);
        //   }
        //   // return resource;
        // });
        this.saveSection(this.section);
        this.toggleSectionEditingSettings(this.section);
      } else {
        // TODO: can even get here ?
        // this.saveSection(this.section);
        // setTimeout(() => {
        //   const hasSectionsToInitialize = this.$store.state.activeTemplate.data.sections.filter((sect) => !sect.isInitialized).length;
        //   if (hasSectionsToInitialize) {
        //     // this.selectNextSection();
        //   } else {
        //     // close nav
        //     this.$store.commit('updateState', {
        //       path: 'activeTemplate.isWizardEnabled',
        //       value: false,
        //     });
        //     this.showBuildDialog();
        //   }
        // }, 1000);
      }
      // show next button
      // this.shouldShowNextBtn = true;
    },
  },
};
</script>
